import { NgModule, Component } from '@angular/core';
import { BreadcrumbsComponent } from './breadcrumb.component';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { ApiConstants } from './api.constants';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { AssetService } from './asset.service';
import { OrderByPipe } from './order-by.pipe';
import { FilterPipe } from './filter.pipe';
import { BusyIndicatorComponent } from './busy.indicator.component';
import { HighlightPipe } from './highlight.pipe';
import { KeysPipe } from './keys.pipe';
import { P404Component } from './404.component';
import { P500Component } from './500.component';
import { AsideToggleDirective } from './aside.directive';

@NgModule({
   declarations: [
      BreadcrumbsComponent,
      OrderByPipe,
      FilterPipe,
      BusyIndicatorComponent,
      HighlightPipe,
      KeysPipe,
      P404Component,
      P500Component,
      AsideToggleDirective
   ],
   exports: [
      BreadcrumbsComponent,
      OrderByPipe,
      FilterPipe,
      HighlightPipe,
      KeysPipe,
      BusyIndicatorComponent,
      P404Component,
      P500Component,
      AsideToggleDirective
   ],
   imports: [
      HttpModule,
      BrowserModule,
      RouterModule,
      SimpleNotificationsModule.forRoot()
   ],
   providers: [
      ApiConstants,
      AssetService
   ]
})
export class SharedModule {

}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts